import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: String(process.env.REACT_APP_TAG_MANAGER_ID),
};

export function initializeTagManager() {
  TagManager.initialize(tagManagerArgs);
}
